import { TabProps } from '@approvalmax/ui/src/components/Tabs/components';

import { messages } from './ReportEditPopup.messages';
import { ActiveTab } from './ReportEditPopup.types';

export const tabsItems: TabProps<'div'>[] = [
    {
        label: messages.tabReportType,
        value: ActiveTab.ReportType,
    },
    {
        label: messages.tabVisibleColumns,
        value: ActiveTab.VisibleColumns,
    },
    {
        label: messages.tabFilters,
        value: ActiveTab.Filters,
    },
];
